Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.default = setInterval.bind(globalThis);